<app-header></app-header>
<main id="main-content" tabindex="-1">
    <app-breadcrumb></app-breadcrumb>
    <a href="https://wa.me/3513465069?text=Ciao,%20vorrei%20informazioni" target="_blank" class="whatsapp-float" aria-label="Contattaci su WhatsApp">
        <i class="bi bi-whatsapp"></i>
    </a>
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>

<!-- Scroll Up -->
<!-- <div id="back-top">
  <a title="Go to Top" href="#"> <i class="fas fa-level-up-alt"></i></a>
</div> -->

<!-- ? Preloader Start -->
<!--     <div id="preloader-active">
        <div class="preloader d-flex align-items-center justify-content-center">
            <div class="preloader-inner position-relative">
                <div class="preloader-circle"></div>
                <div class="preloader-img pere-text">
                    <img src="resources/img/logo/loder.png" alt="">
                </div>
            </div>
        </div>
    </div> -->
<!-- Preloader Start -->